import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PageHero, Reveal, SectionHead, StatusPill } from "@/components/site/Section";
import { AssistantsCarousel } from "@/components/site/AssistantsCarousel";
import { FEATURES, IMG } from "@/data/content";

const DETAILS = {
  "content-studio": ["Social posts, blogs, emails, ad and webinar copy", "Grounded in your Brand Profile & Knowledge Base", "Choose Claude Sonnet 4.5 or Gemini 3 Flash", "Credit cost shown before every run"],
  "content-calendar": ["AI-generated two-week content calendar", "Pick channels, themes and posting frequency", "Drag ideas into drafts in one click", "Month view of planned, scheduled and published items"],
  "social-media": ["LinkedIn, Facebook & Instagram formatting", "Approval before anything is published", "Scheduling & publication status tracking", "Demo-mode publishing while API approvals complete"],
  "seo-blog": ["SEO content briefs with keywords & intent", "WordPress-ready blog drafts in Markdown", "Meta title & description suggestions", "No guaranteed rankings — practical guidance only"],
  "campaign-planning": ["Meta & LinkedIn campaign drafts", "Headlines, primary texts, CTAs & creative briefs", "Audience and budget suggestions", "Explicit confirmation before any activation"],
  analytics: ["Weekly plain-English performance summary", "Reach, engagement & click trends", "Channel mix breakdown", "Illustrative data until channels are connected"],
};

export default function Platform() {
  return (
    <div data-testid="platform-page">
      <PageHero eyebrow="Platform · AI Marketing Agents" title={<>One workspace for <span className="text-gradient">plan, create, approve, publish & measure.</span></>}
        copy="Sliance brings specialized AI marketing assistants together with human approval workflows, so your team stays in control while doing more with less." img={IMG.dashboard}>
        <Link to="/tour" className="btn-brand" data-testid="platform-tour-btn">Take the Product Tour <ArrowRight className="h-4 w-4" /></Link>
        <Link to="/pricing" className="btn-ghost">View Pricing</Link>
      </PageHero>
      <section className="py-20 md:py-24">
        <div className="container-x">
          <SectionHead eyebrow="AI marketing agents" title="Specialized assistants, honest status labels" />
          <div className="mt-12"><AssistantsCarousel /></div>
        </div>
      </section>
      {FEATURES.map((f, i) => (
        <section key={f.slug} id={f.slug} className={`py-20 md:py-24 border-t scroll-mt-20 ${i % 2 ? "bg-card/40" : ""}`}>
          <div className="container-x grid lg:grid-cols-12 gap-12 items-center">
            <Reveal className={`lg:col-span-6 ${i % 2 ? "lg:order-2" : ""}`}>
              <img src={f.img} alt={f.title} className="aspect-[16/11] w-full rounded-[1.75rem] object-cover border" />
            </Reveal>
            <div className="lg:col-span-6">
              <div className="h-12 w-12 rounded-xl flex items-center justify-center" style={{ background: `${f.color}1f`, color: f.color }}><f.icon className="h-6 w-6" /></div>
              <h2 className="mt-6 text-3xl sm:text-4xl font-bold tracking-tight">{f.title}</h2>
              <p className="mt-4 text-muted-foreground text-lg leading-relaxed">{f.copy}</p>
              <ul className="mt-7 space-y-3">
                {DETAILS[f.slug].map((d) => <li key={d} className="flex gap-3"><Check className="h-5 w-5 shrink-0" style={{ color: f.color }} />{d}</li>)}
              </ul>
              <div className="mt-8 flex items-center gap-3">
                <Link to="/register" className="btn-brand" data-testid={`platform-start-${f.slug}`}>Get Started</Link>
                {f.slug === "social-media" && <StatusPill status="Demo" />}
              </div>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
